import { axiosAiq } from 'config';

export const fetchDraftMailTypes = async () => {
    const response = await axiosAiq.get('/api/gmail/types');
    const { data } = response;
    return data;
};
